import React, { useState, useEffect, useRef, useImperativeHandle } from "react";
import "../styles/AddUser.css";
import PersonIcon from "../icons/SignInIcon/PersonIcon.js";
import EmailIcon from "../icons/SignInIcon/EmailIcon.js";
import GenderIcon from "../icons/BusinessHub/GenderIcon.js";
import RoleIcon from "../icons/BusinessHub/RoleIcon.js";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import { parsePhoneNumberFromString, AsYouType } from "libphonenumber-js";
import ReactCountryFlag from "react-country-flag";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import Utils from "../utils/Utils";
import CountriesController from "../controllers/CountriesController.js";
import userController from "../controllers/userController.js";
import { userService } from "../services/userService";
import { useLocation } from "react-router-dom";
import CustomDropdown from "./StatusDropdown.js";
import SingleDatePicker from "./SingleDatePicker.js";

function UserInfoInput({ RoleID, setRoleid, ref, UserAdd, mode, user }) {
  const { userId } = user || {};
  const { state } = useLocation();
  const roleName = state?.roleName;
  const [phoneDialCode, setPhoneDialCode] = useState(null);
  const [countryofres, setcountyofres] = useState();
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [phoneCountry, setPhoneCountry] = useState(null);
  const [countries, setCountries] = useState([]);
  const [phone, setPhone] = useState("");
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [email, setEmail] = useState("");
  const [birthdate, setBirthdate] = useState(null);
  const [gender, setGender] = useState("");
  const containerRef = useRef(null);
  const [jwt, setjwt] = useState("");
  const [data, setData] = useState([]);
  // const [compID, setCompanyID] = useState("");
  const [usedata, setuserData] = useState([]);
  const [genderName, setgenderName] = useState(user?.genderName || "");
  const compID = userService.getCompID();
  useImperativeHandle(ref, () => ({
    getData: () => ({
      phone,
      fname,
      lname,
      email,
      birthdate,
      roleID: RoleID,
      gender,
      phoneDialCode,
      countryofres,
    }),
  }));

  useEffect(() => {
    setjwt(userService.getUser());
  }, []);

  useEffect(() => {
    if (!jwt || !userId) return;
    const getuser = async () => {
      const userdata = await userController.getUser({
        Jwt: userService.getUser(),
        userID: userId,
      });

      setuserData(userdata.data);
      setgenderName(userdata?.data?.gender?.genderName);
    };
    getuser();
  }, [jwt]);

  useEffect(() => {
    if (countries.length === 0) return;

    const matchedCountry = countries.find(
      (c) => c.value === phoneCountry && c.dialCode === phoneDialCode,
    );

    setcountyofres(matchedCountry || null);
  }, [phoneCountry, phoneDialCode, countries]);

  useEffect(() => {
    if (!jwt || !compID) return;
    const getData = async () => {
      const perm = await userController.GetRoles({
        jwt: jwt,
        companyId: compID,
        application: 4,
      });
      setData(
        Array.isArray(perm?.data)
          ? perm.data.filter((role) => role.roleName !== "Root Admin")
          : [],
      );
    };
    getData();
  }, [jwt, compID]);

  useEffect(() => {
    const GetCountries = async () => {
      const res = await CountriesController.getCountries();
      if (res?.data) {
        setCountries(
          res.data.map((c) => ({
            value: c.countryCode,
            label: c.countryName,
            dialCode: c.suffix,
          })),
        );
      }
    };
    GetCountries();
  }, []);

  useEffect(() => {
    setPhone("");
    setIsPhoneValid(false);
  }, [phoneCountry]);

  const formatPhoneOption = (option) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <ReactCountryFlag
        countryCode={option.value}
        svg
        style={{ width: "1.3em", height: "1.3em" }}
      />
      <span>{option.dialCode}</span>
    </div>
  );
  const handlePhoneChange = (value) => {
    if (!phoneCountry) return;
    const formatted = new AsYouType(phoneCountry).input(value);
    const rawNumber = formatted.replace(/\s+/g, "");
    setPhone(rawNumber);
    const phoneNumber = parsePhoneNumberFromString(rawNumber, phoneCountry);
    setIsPhoneValid(phoneNumber?.isValid() || false);
  };
  return (
    <div className="user-window-body">
      <div className="user-data-rows">
        <div className="user-data-container">
          <div className="user-data-container-title">
            First Name<div className="obligatory">*</div>
          </div>
          <div className="user-input-container">
            <div className="user-input-icon">
              <PersonIcon />
            </div>
            {mode === "edit" && (
              <input
                disabled
                placeholder={usedata.firstname}
                className="user-data-input"
              ></input>
            )}
            {mode === "add" && (
              <input
                className="user-data-input"
                value={fname}
                onChange={(f) => {
                  setfname(f.target.value);
                }}
              ></input>
            )}
          </div>
        </div>
        <div className="user-data-container">
          <div className="user-data-container-title">
            Last Name<div className="obligatory">*</div>
          </div>
          <div className="user-input-container">
            <div className="user-input-icon">
              <PersonIcon />
            </div>
            {mode === "edit" && (
              <input
                disabled
                className="user-data-input"
                placeholder={usedata.lastname}
              ></input>
            )}
            {mode === "add" && (
              <input
                className="user-data-input"
                value={lname}
                onChange={(l) => {
                  setlname(l.target.value);
                }}
              ></input>
            )}
          </div>
        </div>
      </div>
      <div className="user-data-rows">
        <div className="user-data-container">
          <div className="user-data-container-title">
            Email Address<div className="obligatory">*</div>
          </div>
          <div className="user-input-container">
            <div className="user-input-icon">
              <EmailIcon />
            </div>
            {mode === "edit" && (
              <input
                disabled
                className="user-data-input"
                placeholder={usedata.email}
              ></input>
            )}
            {mode === "add" && (
              <input
                className="user-data-input"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value.toLowerCase());
                }}
              ></input>
            )}
          </div>
          {email && !Utils.checkEmailFormat(email) && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Please enter a valid email address
            </div>
          )}
        </div>
        <div className="user-data-container">
          <div className="user-data-container-title">
            Phone Number<div className="obligatory">*</div>
          </div>
          <div className="user-input-container">
            {mode === "add" && (
              <div className="user-input-flag">
                {!UserAdd && (
                  <Select
                    options={countries}
                    value={
                      countries.find(
                        (c) =>
                          c.value === phoneCountry &&
                          c.dialCode === phoneDialCode,
                      ) || null
                    }
                    formatOptionLabel={formatPhoneOption}
                    onChange={(selected) => {
                      setPhoneCountry(selected.value);
                      setPhoneDialCode(selected.dialCode);
                      setPhone("");
                      setIsPhoneValid(false);
                    }}
                    filterOption={(option, inputValue) => {
                      const search = inputValue.toLowerCase().trim();

                      return (
                        option.data.label?.toLowerCase().includes(search) ||
                        option.data.value?.toLowerCase().includes(search) ||
                        String(option.data.dialCode || "").includes(search) ||
                        `+${option.data.dialCode || ""}`.includes(search)
                      );
                    }}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                        height: "100%",
                      }),
                      control: (base) => ({
                        ...base,
                        justifyContent: "center",
                        border: "none",
                        backgroundColor: "transparent",
                        paddingLeft: "10px",
                        cursor: "pointer",
                        height: "20px",
                        width: "95px",
                        minHeight: "20px",
                        boxShadow: "none",
                        "&:hover": { border: "none" },
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                      }),
                      input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                        color: "initial",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "initial",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        padding: 0,
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        padding: 0,
                      }),
                      indicatorSeparator: () => ({
                        display: "none",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                        color: "initial",
                        margin: 0,
                      }),
                      menu: (base) => ({
                        ...base,
                        // zIndex: 9999,
                      }),
                    }}
                  />
                )}
              </div>
            )}
            {/**               */}

            {mode === "edit" && (
              <input
                disabled
                placeholder={"  +" + usedata.suffix + " " + usedata.phoneNumber}
                className="user-data-input"
              />
            )}
            {mode === "add" && (
              <input
                className="user-data-input-phone"
                value={
                  phoneCountry
                    ? new AsYouType(phoneCountry).input(phone)
                    : phone
                }
                onChange={(e) => {
                  setPhone(e.target.value);
                  handlePhoneChange(e.target.value);
                }}
              />
            )}
          </div>
          {phone && !isPhoneValid && (
            <div className="add-user-phone-error">
              Please enter a valid phone number
            </div>
          )}
        </div>
      </div>
      <div className="user-data-rows">
        <div className="user-data-container">
          <div className="user-data-container-title">
            Birthdate<div className="obligatory">*</div>
          </div>
          <div className="user-input-birthday-container">
            {mode === "edit" && (
              <input
                // type="date"
                placeholder={usedata.birthdate}
                disabled
                className="birthday-date-input"
              />
            )}
            {mode === "add" && (
              <SingleDatePicker
                value={birthdate || ""}
                onChange={setBirthdate}
                className="birthday-date-pickers"
              />
            )}
          </div>
        </div>
        <div className="user-data-container">
          <div className="user-data-container-title">
            Gender <div className="obligatory">*</div>
          </div>

          {mode === "edit" && (
            <div className="user-input-container">
              <div className="user-input-icon">
                <GenderIcon />
              </div>
              <input
                disabled
                placeholder={genderName}
                className="user-data-input"
              ></input>
            </div>
          )}
          {mode === "add" && (
            <CustomDropdown
              rightIcon={<ArrowDownIcon />}
              value={gender}
              onChange={setGender}
              placeholder="Select gender"
              options={[
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
              ]}
              className="filter-popup-container-rows-input-container-gender"
              menuClassName="status-drop-menu-container"
              optionClassName="status-drop-menu-option"
            />
          )}
        </div>
      </div>
      <div className="user-data-rows">
        <div className="user-data-container">
          <div className="user-data-container-title">
            Role<div className="obligatory">*</div>
          </div>

          <div className="user-data-input">
            <CustomDropdown
              leftIcon={<RoleIcon />}
              rightIcon={<ArrowDownIcon />}
              value={RoleID}
              onChange={setRoleid}
              placeholder="Select Category"
              options={
                Array.isArray(data)
                  ? data.map((item) => ({
                      label: item.roleName,
                      value: item.roleID,
                    }))
                  : []
              }
              className="filter-popup-container-rows-input-container"
              menuClassName="status-drop-menu-container"
              optionClassName="status-drop-menu-option"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserInfoInput;
